// Momo API endpoints
export const MOMO_GATEWAY_SANDBOX_HOST = "https://test-payment.momo.vn";
export const MOMO_GATEWAY_PRODUCTION_HOST = "https://payment.momo.vn";

// API endpoints
export const CREATE_PAYMENT_ENDPOINT = "/v2/gateway/api/create";
export const QUERY_TRANSACTION_ENDPOINT = "/v2/gateway/api/query";
export const REFUND_TRANSACTION_ENDPOINT = "/v2/gateway/api/refund";
export const CONFIRM_TRANSACTION_ENDPOINT = "/v2/gateway/api/confirm";
export const GET_BANK_LIST_ENDPOINT = "/v2/gateway/api/bankcodes";